import { cn } from '@/lib/utils';

/**
 * オン/オフ。角丸を使わない設計なので、丸いスイッチではなく
 * 矩形を左右に寄せる形にする。
 */
export function Toggle({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'flex h-5 w-9 shrink-0 items-center border p-0.5 transition-colors disabled:opacity-50',
        checked ? 'border-brand-700 bg-brand-700' : 'border-line-bold bg-surface',
      )}
    >
      <span
        className={cn(
          'block h-4 w-4 transition-transform',
          checked ? 'translate-x-4 bg-surface-raised' : 'translate-x-0 bg-line-bold',
        )}
      />
    </button>
  );
}
